<!--Translated-->
<template>
  <article class="rightzone">
    <div class="rightzone_top">
      <Breadcrumps :data="[{ title: $t('DefensePrograms:Title') }]" />

      <div class="rightzone_top-buttonswrap">
        <Button
          :text="$t('DefensePrograms:ButtonAdd')"
          size="standart"
          color="accent"
          icon="plus"
          :is-loading="false"
          :loading-left="false"
          :disabled="!canEdit"
          @click="$router.push({ name: 'NewDefenseProgram' })"
        />
      </div>
    </div>

    <div class="rightzone_block">
      <div class="filter">
        <div class="filter-inputszone">
          <div class="filterwrap filterwrap--clients">
            <div class="filterwrap_line">
              <Input
                type="text"
                :placeholder="$t('DefensePrograms:Filter:Name.Placeholder')"
                :label="$t('DefensePrograms:Filter:Name.Label')"
                icon="search"
                size="long"
                v-model="filters.name"
              />

              <DropdownSelectValue
                :placeholder="$t('DefensePrograms:Filter:Creators:Placeholder')"
                :label="$t('DefensePrograms:Filter:Creators:Label')"
                size="standart"
                dd-max-elements="5"
                :notSelectedText="
                  $t('DefensePrograms:Filter:Creators:NotSelected')
                "
                :options="[
                  {
                    text: $t('DefensePrograms:Filter:Creators:Manager'),
                    value: 0,
                  },
                  {
                    text: $t('DefensePrograms:Filter:Creators:Client'),
                    value: 1,
                  },
                ]"
                v-model="filters.creatorType"
              />
            </div>

            <div class="filterwrap_line">
              <Input
                type="text"
                :placeholder="
                  $t('DefensePrograms:Filter:NameClient.Placeholder')
                "
                :label="$t('DefensePrograms:Filter:NameClient.Label')"
                size="long"
                v-model="filters.clientName"
              />
              <Input
                type="text"
                :placeholder="$t('DefensePrograms:Filter:Code.Placeholder')"
                :label="$t('DefensePrograms:Filter:Code.Label')"
                size="standart"
                v-model="filters.code"
              />
            </div>

            <!-- <div class="filterwrap_line">

                <Input
                 placeholder="Введите номер..."
                 label="Телефон"
                 state="disabled"
                 size="standart"
               />

               <Input
                 type="text"
                 placeholder="Введите Email..."
                 label="Email"
                 state="disabled"
                 size="long"
               />
             </div> -->

            <div class="filterwrap_line">
              <CultureSelect
                ref="culture"
                :categories="categories"
                :cultures="cultures"
                :category="filters.cultureCategory"
                v-model="filters.culture"
                @categorySelect="filters.cultureCategory = $event"
              />
              <CultureAgeSelect v-model="filters.age" />
              <CalcMethodSelect v-model="filters.calcMethod" />
            </div>

            <div class="filterwrap_line">
              <LocationSelect
                ref="location"
                :geoEntries="geoMapped"
                :freeSelect="true"
                :type="2"
                v-model="filters.geo"
              />
            </div>
          </div>
        </div>

        <div class="filter-clearbtnzone">
          <Button
            class="filter_buttonclear"
            text="очистить"
            size="s-standart"
            icon="backspace"
            :is-loading="false"
            :loading-left="true"
            :color="filtersApplied ? 'accentlines' : 'graylines'"
            @click="reset"
          />
        </div>
      </div>
    </div>

    <div class="rightzone_table">
      <Table
        :headers="headers"
        :dataArr="rows"
        @editClick="editProgram"
        @printClick="printProgram"
        :tableLoading="isLoading"
        :loadingCountItems="10"
      >
        <template v-slot:warning-icons>
          <div v-svg="{ name: 'warningdiese' }"></div>
          <div v-svg="{ name: 'user' }"></div>
        </template>
      </Table>
    </div>

    <PrintModal
      v-if="selectedPrintId"
      @close="selectedPrintId = null"
      :selectedPrintId="selectedPrintId"
    />
  </article>
</template>

<script>
import isEqual from 'lodash.isequal';
import { mapGetters, mapState } from 'vuex';

import routeNames from '@/router/routeNames';

import Breadcrumps from '@/components/views/Breadcrumps';
import DropdownSelectValue from '@/components/views/wrappers/DropdownSelectValue';
import Button from '@/components/views/Button';
import Input from '@/components/views/Input';
import Table from '@/components/tables/Table';
import CultureSelect from '@/components/views/CultureSelect';
import LocationSelect from '@/components/views/LocationSelect';
import CultureAgeSelect from '@/components/views/CultureAgeSelect';
import CalcMethodSelect from '@/components/views/CalcMethodSelect';
import PrintModal from '@/components/modals/ModalPrint';

import { staticData } from '@/store/modules/plantsCare';
import { mapInputEntityWithMerge } from '@/components/adapters/mapInput';
import { mutationTypes } from '@/store/modules/filtersState';
//При изменении фильтра не забыть изменить базовый в вьюъексе (сохранение состояния)
const defaultFilters = {
  name: '',
  creatorType: null,
  clientName: '',
  code: '',
  cultureCategory: null,
  culture: null,
  age: null,
  calcMethod: null,
  geo: null,
};

export default {
  name: 'DefensePrograms',
  components: {
    Input,
    Button,
    Breadcrumps,
    Table,
    LocationSelect,
    DropdownSelectValue,
    CultureSelect,
    CultureAgeSelect,
    CalcMethodSelect,
    PrintModal,
  },
  data() {
    return {
      filters: { ...defaultFilters },
      selectedPrintId: null,
    };
  },
  computed: {
    ...mapGetters(['geoMapped', 'geoPlainDataAsMap']),
    ...mapState({
      isLoading: (state) => state.programsList.isLoading,
      canEdit: (state) =>
        state.auth.currentUserRole?.claim_plants_care_add === 1,
      programs: (state) => state.programsList.programs,
      categories: (state) =>
        state.programsList.categoriesCultures.map(mapInputEntityWithMerge),
      cultures: (state) =>
        state.programsList.cultures.map(mapInputEntityWithMerge),
    }),
    headers() {
      return [
        {
          text: '',
          class: 'col-warning',
          icon: 'warningdiese',
          type: 'warning',
        },
        {
          text: this.$t('DefensePrograms:TableHeaders:0'), //'Имя клиента',
          type: 'text',
          width: '22%',
        },
        {
          text: this.$t('DefensePrograms:TableHeaders:1'), //'Название',
          type: 'text',
          width: '22%',
        },
        {
          text: this.$t('DefensePrograms:TableHeaders:2'), //'Культура',
          type: 'text',
          width: '13%',
        },
        {
          text: this.$t('DefensePrograms:TableHeaders:3'), //'Возраст',
          type: 'text',
          width: '10%',
        },
        {
          text: this.$t('DefensePrograms:TableHeaders:4'), //'Метод',
          type: 'text',
          width: '10%',
        },
        {
          text: this.$t('DefensePrograms:TableHeaders:5'), // Создатель
          type: 'text',
          width: '13%',
        },
        {
          text: this.$t('DefensePrograms:TableHeaders:6'), //'Площадь',
          type: 'text',
          width: '10%',
        },
        {
          class: 'col-edit unicol-colordark',
          type: 'print',
          icon: 'print',
        },
        {
          class: 'col-edit',
          type: 'edit',
          icon: this.canEdit ? 'edit' : 'passwordshow',
        },
      ];
    },
    filtersApplied() {
      return !isEqual(this.filters, defaultFilters);
    },
    rows() {
      const f = this.filters;

      const mapper = (row) => ({
        ...row,
        culture: this.cultures.find(({ id }) => row.culture_id === id),
        methodName:
          staticData.calculationMethodsShort[row.calculation_method_id],
        regionName: this.geoPlainDataAsMap.get(row.geo_id)?.name,
        geoChain:
          this.geoPlainDataAsMap.get(row.geo_id)?.order?.map((e) => e.id) ?? [],
      });

      const mapToRow = (input) =>
        [
          input.creator_status,
          input.client_name,
          input.name,
          input.culture.name,
          input.culture_age,
          input.methodName,
          input.creatorName,
          input.place_area,
          input.id,
          input.id,
        ].map((text, index) => ({
          text: index === 4 && text === 0 ? '< 1' : text,
        }));

      const filter = (row) =>
        row.name.includes(f.name) &&
        (f.creatorType === null
          ? true
          : row.creator_status === f.creatorType) &&
        (row.client_name.toLowerCase().includes(f.clientName.toLowerCase()) ||
          row.creatorName.toLowerCase().includes(f.clientName.toLowerCase())) &&
        (f.code ? String(row.client_code).includes(f.code) : true) &&
        (f.culture === null
          ? f.cultureCategory === null
            ? true
            : this.cultures
                .filter(({ category_id }) => category_id === f.cultureCategory)
                .some((c) => c.id === row.culture.id)
          : f.culture === row.culture_id) &&
        (f.age === null
          ? true
          : f.age === 11
          ? f.age <= row.culture_age
          : f.age === row.culture_age) &&
        (f.calcMethod === null
          ? true
          : f.calcMethod == row.calculation_method_id) &&
        (f.geo === null ? true : row.geoChain.includes(f.geo));

      return this.programs.map(mapper).filter(filter).map(mapToRow);
    },
  },
  methods: {
    reset() {
      this.filters = { ...defaultFilters };
      this.$refs.location.reset();
      this.$refs.culture.reset();
    },
    editProgram(id) {
      this.$router.push({
        name: routeNames.editDefenseProgram,
        params: { id },
      });
    },
    printProgram(id) {
      this.selectedPrintId = id;
    },
  },
  watch: {
    filters: {
      handler(val) {
        this.$store.commit(mutationTypes.setFilterPlantsCarePrograms, {
          ...val,
        });
      },
      deep: true,
    },
  },
  created() {
    //console.log(this.filters);
    for (let filterKey in this.filters) {
      this.filters[filterKey] =
        this.$store.state.filtersState.filterPlantsCarePrograms[filterKey];
    }
  },
};
</script>
